/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { firstValueFrom } from "rxjs";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getSubscriptionHealthStatus } from "../fn/health/get-subscription-health-status";
import { GetSubscriptionHealthStatus$Params } from "../fn/health/get-subscription-health-status";
import { getSubscriptionInstanceHealthStatus } from "../fn/health/get-subscription-instance-health-status";
import { GetSubscriptionInstanceHealthStatus$Params } from "../fn/health/get-subscription-instance-health-status";
import { getWirelessHealthDetail } from "../fn/health/get-wireless-health-detail";
import { GetWirelessHealthDetail$Params } from "../fn/health/get-wireless-health-detail";
import { getWirelessHealthStatus } from "../fn/health/get-wireless-health-status";
import { GetWirelessHealthStatus$Params } from "../fn/health/get-wireless-health-status";
import { HealthStatus } from "../models/health-status";
import { WirelessHealthDetail } from "../models/wireless-health-detail";
import { WirelessHealthStatus } from "../models/wireless-health-status";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class HealthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getWirelessHealthStatus()` */
  static readonly GetWirelessHealthStatusPath = "/dashboard/health/wireless/{subscription_id}";

  /**
   * Get Wireless Health Status.
   *
   * Retrieve Wireless location HealthStatus.
   *
   * Args:
   *     subscription_id: subscription id of the location.
   *     count_num_access_points: Whether to count the number of access points registered in Jira or not.
   *         This is useful when the data source behind it is badly reachable.
   *     db: Mongo database
   *
   * Returns:
   *     WirelessHealthStatus
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWirelessHealthStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWirelessHealthStatus$Response(
    params: GetWirelessHealthStatus$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<WirelessHealthStatus>> {
    const obs = getWirelessHealthStatus(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Wireless Health Status.
   *
   * Retrieve Wireless location HealthStatus.
   *
   * Args:
   *     subscription_id: subscription id of the location.
   *     count_num_access_points: Whether to count the number of access points registered in Jira or not.
   *         This is useful when the data source behind it is badly reachable.
   *     db: Mongo database
   *
   * Returns:
   *     WirelessHealthStatus
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWirelessHealthStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWirelessHealthStatus(
    params: GetWirelessHealthStatus$Params,
    context?: HttpContext,
  ): Promise<WirelessHealthStatus> {
    const resp = this.getWirelessHealthStatus$Response(params, context);
    return resp.then((r: StrictHttpResponse<WirelessHealthStatus>): WirelessHealthStatus => r.body);
  }

  /** Path part for operation `getSubscriptionInstanceHealthStatus()` */
  static readonly GetSubscriptionInstanceHealthStatusPath =
    "/dashboard/health/{subscription_id}/{subscription_instance_id}";

  /**
   * Get Subscription Instance Health Status.
   *
   * Retrieve health status of multiple saps combined.
   *
   * This endpoint will only return status Ok if all saps are okay.
   *
   * Args:
   *     subscription_id: Subscription Id
   *     subscription_instance_id: Instance id
   *     db: Mongo database
   *
   * Returns:
   *     HealthStatus
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionInstanceHealthStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionInstanceHealthStatus$Response(
    params: GetSubscriptionInstanceHealthStatus$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<HealthStatus>> {
    const obs = getSubscriptionInstanceHealthStatus(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Subscription Instance Health Status.
   *
   * Retrieve health status of multiple saps combined.
   *
   * This endpoint will only return status Ok if all saps are okay.
   *
   * Args:
   *     subscription_id: Subscription Id
   *     subscription_instance_id: Instance id
   *     db: Mongo database
   *
   * Returns:
   *     HealthStatus
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionInstanceHealthStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionInstanceHealthStatus(
    params: GetSubscriptionInstanceHealthStatus$Params,
    context?: HttpContext,
  ): Promise<HealthStatus> {
    const resp = this.getSubscriptionInstanceHealthStatus$Response(params, context);
    return resp.then((r: StrictHttpResponse<HealthStatus>): HealthStatus => r.body);
  }

  /** Path part for operation `getWirelessHealthDetail()` */
  static readonly GetWirelessHealthDetailPath = "/dashboard/health/wireless/{subscription_id}/detail";

  /**
   * Get Wireless Health Detail.
   *
   * Retrieve Wireless Location detailed status.
   *
   * Args:
   *     subscription_id: subscription id of the location
   *     db: Mongo database
   *
   * Returns:
   *     Wireless health detailed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWirelessHealthDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWirelessHealthDetail$Response(
    params: GetWirelessHealthDetail$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<WirelessHealthDetail>> {
    const obs = getWirelessHealthDetail(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Wireless Health Detail.
   *
   * Retrieve Wireless Location detailed status.
   *
   * Args:
   *     subscription_id: subscription id of the location
   *     db: Mongo database
   *
   * Returns:
   *     Wireless health detailed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWirelessHealthDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWirelessHealthDetail(
    params: GetWirelessHealthDetail$Params,
    context?: HttpContext,
  ): Promise<WirelessHealthDetail> {
    const resp = this.getWirelessHealthDetail$Response(params, context);
    return resp.then((r: StrictHttpResponse<WirelessHealthDetail>): WirelessHealthDetail => r.body);
  }

  /** Path part for operation `getSubscriptionHealthStatus()` */
  static readonly GetSubscriptionHealthStatusPath = "/dashboard/health/{subscription_id}";

  /**
   * Get Subscription Health Status.
   *
   * Retrieve the health status for a subscription.
   *
   * Args:
   *     subscription_id: The subscription id to be queried
   *     db: Mongo database
   *
   * Returns:
   *     HealthStatus object.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionHealthStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionHealthStatus$Response(
    params: GetSubscriptionHealthStatus$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<HealthStatus>> {
    const obs = getSubscriptionHealthStatus(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Subscription Health Status.
   *
   * Retrieve the health status for a subscription.
   *
   * Args:
   *     subscription_id: The subscription id to be queried
   *     db: Mongo database
   *
   * Returns:
   *     HealthStatus object.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionHealthStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionHealthStatus(
    params: GetSubscriptionHealthStatus$Params,
    context?: HttpContext,
  ): Promise<HealthStatus> {
    const resp = this.getSubscriptionHealthStatus$Response(params, context);
    return resp.then((r: StrictHttpResponse<HealthStatus>): HealthStatus => r.body);
  }
}
